module.exports = __webpack_public_path__ + "img/publishing-icon.333d8811.png";